/*
 * 文件EN: merActivate.js,
 * 文件CN: 商户激活

 */

import * as Models from '@/api/T7/merActivate'

export default {
  namespaced: true,
  state: {
    checkoutListData: []
  },
  getters: {
    checkoutListData: state => state.checkoutListData
  },
  mutations: {
    setCheckoutListData: (state, data) => {
      state.checkoutListData = data;
    }
  },
  actions: {
    // 获取列表
    async getList(ctx, payload) {
      return await Models.getListData(payload).then(res => {
        return res
      })
    },

    // 批量商户激活
    async batchUpdate(ctx, payload) {
      return await Models.batchUpdate(payload).then(res => {
        return res
      })
    },


    // 批量商户激活
    async activate(ctx, payload) {
      return await Models.activate(payload).then(res => {
        return res
      })
    },

  }
}